var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [_vm.right ? "float-right" : "", "d-flex justify-content-between"]
    },
    [
      _c("span", { class: { "pr-1": _vm.sortedBy == _vm.sortProperty } }, [
        _vm._v(_vm._s(_vm.$t(_vm.title)))
      ]),
      _vm._v(" "),
      _vm.sortedBy == _vm.sortProperty && _vm.sortedAsc == true
        ? _c("i", { staticClass: "fas fa-15 fa-sort-up" })
        : _vm._e(),
      _vm._v(" "),
      _vm.sortedBy == _vm.sortProperty && _vm.sortedAsc == false
        ? _c("i", { staticClass: "fas fa-15 fa-sort-down" })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }